import { render, staticRenderFns } from "./BarChartEChartsConfiged.vue?vue&type=template&id=4bf59932&"
import script from "./BarChartEChartsConfiged.vue?vue&type=script&lang=js&"
export * from "./BarChartEChartsConfiged.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports